/**
 * Public id: path /pub/<id> or /pub/<instance>/<id_public> or query ?pubId= / ?id= (local dev).
 */
export function getPublicIdFromLocation() {
  const { pathname, search } = window.location;
  const m = pathname.match(/^\/pub\/(.+?)\/?$/);
  if (m) {
    const rest = m[1].replace(/\/$/, '');
    return rest.split('/').map((s) => decodeURIComponent(s)).join('/');
  }
  const params = new URLSearchParams(search);
  return params.get('pubId') || params.get('id') || null;
}

/**
 * When Portunus serves HTML (browser Accept: text/html), it injects the same JSON
 * into <script type="application/json" id="pub-portal-initial-data"> (server-rendered).
 */
export function readEmbeddedPubPayload() {
  const el = document.getElementById('pub-portal-initial-data');
  if (!el || !el.textContent?.trim()) return null;
  try {
    const data = JSON.parse(el.textContent);
    if (data && typeof data === 'object' && data.ok !== false) return data;
  } catch {
    return null;
  }
  return null;
}

/**
 * Base URL for the Portunus public API (no trailing slash).
 * Dev: set REACT_APP_PUB_API_BASE=https://your-host.tld or use CRA proxy + relative /pub/...
 */
export function getPubApiBase() {
  const base = process.env.REACT_APP_PUB_API_BASE || '';
  return String(base).replace(/\/$/, '');
}

export async function fetchPubPayload(publicId) {
  const base = getPubApiBase();
  const segments = String(publicId).split('/').filter(Boolean);
  const path = segments.map((s) => encodeURIComponent(s)).join('/');
  const url = `${base}/pub/${path}`;
  const res = await fetch(url, {
    headers: { Accept: 'application/json' },
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  return { res, data };
}
